<template>
  <div class="animated fadeIn">
    <b-row class="my-3">
      <b-col>
        <h4 class="text-center text-primary">
          <i class="fa fa-check-square text-primary mr-2"></i>
          Editar Lista de Distribución
        </h4>
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-card class="w-100">
        <b-form @submit.prevent="store" autocomplete="off">
          <b-row class="pb-2">
            <b-col sm="12" md="12">
              <b-form-group
                :horizontal="true"
                label="<strong>Nombre *</strong>"
                label-cols="2"
                label-for="name"
              >
                <b-form-input
                  type="text"
                  id="name"
                  placeholder="Nombre"
                  v-model="distributionList.name"
                  autocomplete="new-name">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="pb-2">
            <b-col sm="12" md="12" lg="4">
              <router-link :to="'/communications/distribution-list/search?distributionListUUId='+distributionList.uuid">
                <b-card
                  :class="{ 'bg-light': distributionList.search.selectedEntity === '', 'bg-primary': distributionList.search.selectedEntity !== '' }"
                  class="text-center align-center py-5"
                  @click="handleSearchCardClick">
                  <h5 :style="{ color: distributionList.search.selectedEntity !== '' ? 'white' : '' }"  class="card-title mb-0">Socios/No Socios</h5>
                  <p v-if="memberSearchCount > 0" :style="{ color: memberSearchCount > 0 ? 'white' : '' }">
                    {{ memberSearchCount }} Socios de {{ totalMembers }}
                  </p>
                  <p v-else>Búsqueda Socios</p>
                </b-card>
              </router-link>
            </b-col>
            <b-col sm="12" md="12" lg="4">
              <router-link :to="'/communications/distribution-list/list-contact?distributionListUUId='+distributionList.uuid">
                <b-card
                  :class="{ 'bg-light': distributionList.contacts.length === 0, 'bg-primary': distributionList.contacts.length > 0 }"
                  class="text-center align-center py-5"
                  @click="handleContactsCardClick">
                  <h5 :style="{ color: distributionList.contacts.length > 0 ? 'white' : '' }" class="card-title mb-0">Contactos</h5>
                  <p v-if="newNumberOfSelectedContacts > 0" :style="{ color: newNumberOfSelectedContacts > 0 ? 'white' : '' }">
                    {{ newNumberOfSelectedContacts }} Contactos de {{ newTotalContacts }}
                  </p>
                  <p v-else>Seleccion manual</p>
                </b-card>
              </router-link>
            </b-col>
            <b-col sm="12" md="12" lg="4">
              <b-card  :class="{'text-center': true,'text-primary': true,'align-center': true,'py-5': true,'bg-light': !distributionList.attachment,'bg-primary': distributionList.attachment}" style="cursor: pointer" @click="handleFileUploadClick">
                <h5 class="card-title mb-0" :style="{ color: distributionList.attachment ? 'white' : '' }">Contactos</h5>
                <p :style="{ color: distributionList.attachment ? 'white' : '' }">Importar fichero</p>
                <input
                  ref="fileInput"
                  type="file"
                  style="display: none;"
                  @change="handleFileInputChange"
                />
              </b-card>
              <a href="#" class="float-right mb-2" @click="downloadExcelFile">Descargar plantilla de fichero</a>
            </b-col>
          </b-row>
          <b-row>
            <div class="col float-left">
              <button
                type="submit"
                class="btn btn-brand btn-primary btn-lg pull-right"
                :disabled="!generalValidate()"
                v-if="mixinCheckPermission('DISTRIBUTION_LIST_EDIT')">
                Guardar
              </button>
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-row>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import locationContactForm from "@/components/location/LocationContactForm.vue";
import { mapGetters } from 'vuex';

export default {
  name: 'editDistributionList',
  components: {
    locationContactForm,
    Multiselect,
  },
  computed: {
    ...mapGetters(['getListMemberSearchResponse', 'getListContactResponse']),
    storedSearchMemberResponse() {
      return this.getListMemberSearchResponse;
    },
    listContactResponse(){
      return this.getListContactResponse;
    }
  },
  data: function () {
    return {
      topmenu: [
        {name: 'Volver', path: '/communications/distribution-list/list', brand: 'fa fa-arrow-left'},
      ],
      numberOfSelectedContacts: 0,
      newNumberOfSelectedContacts: 0,
      totalContacts: 0,
      newTotalContacts: 0,
      memberSearchCount: 0,
      totalMembers: 0,
      selectedContactUUIDs: [],
      newSelectedContactUUIDs: [],
      distributions: [],
      distributionList: {
        uuid: '',
        name: null,
        search: {
          search_fields: [],
          selectedEntity: '',
          fieldsList: []
        },
        newSearch: {
          search_fields: [],
          selectedEntity: '',
          fieldsList: []
        },
      },
      selectedCard: null,
      visible: false,
      cardStates: {
        contacts: false,
        search: false,
        file: false,
        fileSelected: false
      }
    }
  },
  async created(){
    this.$eventHub.$emit('captureMenu', this.topmenu);
    await this.getDistributionList();
  },
  mounted() {
    this.selectedCard = localStorage.getItem('selectedCard') || null;
    if (this.selectedCard === 'file') {
      this.cardStates.file = true;
    } else if (this.selectedCard === 'search') {
      this.cardStates.search = true;
    } else if (this.selectedCard === 'contacts') {
      this.cardStates.contacts = true;
    }
    localStorage.removeItem('selectedCard');
    this.$eventHub.$emit('captureMenu', this.topmenu);
    const storedResponse = this.listContactResponse;
    if (storedResponse) {
      this.newNumberOfSelectedContacts = storedResponse.selectedCount || 0;
      this.newTotalContacts = storedResponse.totalRecords || 0;
      this.newSelectedContactUUIDs = storedResponse.selectedIds;
    }

    const storedSearchMemberResponse = this.storedSearchMemberResponse;
    if (storedSearchMemberResponse){
      this.memberSearchCount = storedSearchMemberResponse.selectedCount || 0;
      this.totalMembers = storedSearchMemberResponse.totalRecords || 0;
      this.distributionList.newSearch.search_fields = storedSearchMemberResponse.searchFields;
      this.distributionList.newSearch.fieldsList = storedSearchMemberResponse.fieldsList;
      this.distributionList.newSearch.selectedEntity = storedSearchMemberResponse.selectedEntity;
    }
  },

  methods: {
    async downloadExcelFile() {
      try {
        // Replace 'file.xlsx' with the actual file name in your public folder
        const fileName = 'contacts.csv';

        const response = await fetch(`/${fileName}`);

        const fileBlob = await response.blob();

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(fileBlob);
        link.download = fileName;

        link.click();
      } catch (error) {
        console.error('Error downloading file:', error);
      }
    },
    async getDistributionList() {
      try {
        this.$_loadingMixin_showLoading();
        const response = await axios.get('distribution-list/' + this.$route.params.uuid);
        this.$_loadingMixin_hideLoading();
        if (response.status === 200) {
          this.$store.commit('SET_CONTACTS', response.data.contacts);
          this.distributionList = Object.assign({}, this.distributionList, response.data);
        }
      } catch (error) {
        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
        return error;
      }
    },
    store() {
      if (!this.distributionList.name) {
        return;
      }

      let formData = new FormData();

      formData.append('name', this.distributionList.name);
      if (this.newSelectedContactUUIDs && this.newSelectedContactUUIDs.length > 0) {
        formData.append('contacts', JSON.stringify(this.newSelectedContactUUIDs));
      } else {
        formData.append('contacts', null);
      }

      if (this.distributionList.newSearch && Object.keys(this.distributionList.newSearch.search_fields).length > 0) {
        formData.append('search', JSON.stringify(this.distributionList.newSearch));
      } else {
        formData.append('search', null);
      }

      const fileFormData = this.prepareFileFormData();
      if (fileFormData) {
        formData.append('file', fileFormData.get('file'));
      }

      let headers = {
        'Content-Type': 'multipart/form-data',
      };

      this.submitData(formData, headers);

    },
    prepareFileFormData() {
      const fileInput = this.$refs.fileInput;
      const file = fileInput.files[0];

      if (file){
        const formData = new FormData();
        formData.append('file', file);

        return formData;
      }else
      {
        return null;
      }
    },
    submitData(data, headers) {
      this.$_loadingMixin_showLoading();
      const uuid = this.distributionList.uuid;

      axios.post(`distribution-list/${uuid}`, data, {
        headers: headers
      })
        .then((response) => {
          this.$_loadingMixin_hideLoading();
          if (response.status === 201) {
            this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
            this.$store.dispatch('clearListContactResponse');
            this.$store.dispatch('clearContactsResponse');
            this.$store.dispatch('clearSearchMemberResponse');
            localStorage.removeItem('selectedCard');
            this.$router.push({ path: '/communications/distribution-list/list'});
          }
        })
        .catch((error) => {
          this.$_loadingMixin_hideLoading();
          this.showApiError(error.response);
        });
    },
    generalValidate() {
      if (!this.distributionList.name) {
        return false;
      } else {
        return true;
      }
    },
    showApiError(response) {
      if (response.status === 400) {
        this.$_notificationMixin_error('Error al guardar la lista de distribución', 'Algo salió mal');
      }
    },
    handleFileUploadClick() {
      this.selectedCard = 'file';
      localStorage.setItem('selectedCard', this.selectedCard);
      this.cardStates.file = true;
      this.cardStates.contacts = false;
      this.cardStates.search = false;
      this.$refs.fileInput.click();
    },
    handleSearchCardClick() {
      this.selectedCard = 'search';
      localStorage.setItem('selectedCard', this.selectedCard);
      this.cardStates.search = true;
      this.cardStates.contacts = false;
      this.cardStates.file = false;
    },
    handleContactsCardClick() {
      this.selectedCard = 'contacts';
      localStorage.setItem('selectedCard', this.selectedCard);
      this.cardStates.contacts = true;
      this.cardStates.search = false;
      this.cardStates.file = false;
    },
    handleFileInputChange(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.cardStates.fileSelected = true;
      } else {
        this.cardStates.fileSelected = false;
      }
    },
  }
}
</script>
<style>
.disabled-card {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
